import type { ConnectionStatus } from '../../hooks/useWebSocket';
import { Cursor } from './Cursor';

interface LiveIndicatorProps {
  status: ConnectionStatus;
  hasEverConnected: boolean;
}

export function LiveIndicator({ status, hasEverConnected }: LiveIndicatorProps) {
  if (status === 'connected') {
    return (
      <span className="flex items-center gap-1.5">
        <span className="relative flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-success opacity-75" />
          <span className="relative inline-flex rounded-full h-3 w-3 bg-success" />
        </span>
        <span className="text-xs font-medium text-success">Live</span>
      </span>
    );
  }

  if (status === 'connecting') {
    return (
      <span className="flex items-center gap-1.5">
        <Cursor className="text-xs" />
        <span className="text-xs text-base-content/70">
          {hasEverConnected ? 'Reconnecting...' : 'Connecting...'}
        </span>
      </span>
    );
  }

  return (
    <span className="flex items-center gap-1.5">
      <span className="w-3 h-3 rounded-full bg-error" />
      <span className="text-xs font-medium text-error">Disconnected</span>
    </span>
  );
}
